import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./coomponents/Navbar";
import LandingPage from "./sections/LandingPage/LandingPage";
import TextSection from "sections/TextSection/TextSection";
import Footer from "sections/Footer/Footer";
import Opinie from "sections/Opinie/Opinie";
import Questions from "sections/Questions/Questions";
import Oferty from "sections/Oferta/Oferta";
import MenuButton from "coomponents/MenuButton/MenuButton";
import ContactButton from "coomponents/ContactButton/ContactButton";
import Contact from "sections/Contact/Contact";
import { PrivacyPolicy } from "sections/PrivacyPolicy/PrivacyPolicy";
import { Toaster } from "react-hot-toast";
import { WalkDiv } from "App.styles";
import Machine from "sections/Machine/Machine";
import styled from "styled-components";

const WalkTitle = styled.h2`
  color: #011638;
  font-size: 40px;
  font-weight: 400;
  width: 100%;
  text-align: center;
  margin: 180px 0 10px 0;
  font-family: "axiforma-light";

  @media (max-width: 800px) {
    font-size: 32px;
    margin-top: 20px;
  }

  @media (max-width: 600px) {
    margin-top: 130px;
    font-size: 20px;
    color: #e88565;
  }
`;

const WalkSubtitle = styled.p`
  color: #657083;
  font-family: "axiforma-light";
  font-size: 16px;
  text-align: center;
  margin: 0 0 32px 0;

  @media (max-width: 600px) {
    font-size: 13px;
    width: 80%;
    margin: 0 auto;
    margin-bottom: 50px;
    margin-top: -5px;
  }
`;

const App = () => {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Toaster
                position="bottom-center"
                reverseOrder={false}
                containerStyle={{ zIndex: 999999999 }}
              />
              <MenuButton />
              <Navbar />
              <LandingPage />
              <Oferty />

              <Opinie />
              <TextSection />
              <Questions />
              <Machine />
              <WalkTitle>Wirtualny spacer po naszym salonie</WalkTitle>
              <WalkSubtitle>
                Odwiedź nas z domu — poczuj klimat zanim wejdziesz
              </WalkSubtitle>

              <WalkDiv>
                <iframe
                  title="Wirtualny spacer po salonie Wolnik Optyk"
                  width="80%"
                  height="70%"
                  src="https://my.matterport.com/show/?m=4xDinpPMg1U"
                  frameBorder="0"
                  allowFullScreen
                  allow="xr-spatial-tracking"
                ></iframe>
              </WalkDiv>
              <Contact />
              <ContactButton />
              <Footer />
            </>
          }
        />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
    </Router>
  );
};

export default App;
